<template>

  <div>
    <div
      class="buymodal-block__body">

      <div
        class="body-info">
        <div
          class="body-info__title">
          Данные об устройстве
        </div>
        <div
          class="body-info__block">
          <div
            class="info-table">
            <div
              v-if="model.imei"
              class="info-table__line">
              <div
                class="label">
                IMEI{{ model.imei2 ? '1' : '' }}

              </div>
              <div
                class="value">
                {{ model.imei }}
              </div>
            </div>
            <div
              v-if="model.imei2"
              class="info-table__line">
              <div
                class="label">
                IMEI2

              </div>
              <div
                class="value">
                {{ model.imei2 }}
              </div>
            </div>
            <div
              class="info-table__line"
              v-for="(item, i) in model.mobile" :key="i"
              v-if="arrayName.find(item => item.key === i)">
              <div
                class="label">
                {{ arrayName.find(item => item.key === i).name }}
              </div>
              <div
                class="value">
                <span v-if="i != 'model'">{{ item }}</span>
              </div>
            </div>
            <div
              v-if="flowType == 'mts'"
              class="info-table__line">
              <div
                class="label">
                Максимальная выгода до
              </div>
              <div
                class="value">
                {{ model.prices['Grade A'] }} {{ user.currency }}
              </div>
            </div>
            </br>
            <div class="prices" v-if="(user.discounts!=null && user.discounts!=0)">
              <div
                class="body-info__title">
                Цена {{ user.org != 22 ? 'и доп.скидка ' : '' }}на это устройство
              </div>
              <div class="chooseNewDevice" v-if="user.discounts!=null && user.discounts!=0">
                <multiselect ref="ms_chooseNewDevice" :searchable="true" v-model="chooseNewDevice" :options="Object.keys(model.discounts)" placeholder="Покупаемое устройство" selectLabel="Выбрать" deselectLabel="Убрать" selectedLabel="Выбрано" ></multiselect>
              </div>
              <div class="wrapper">
                <!-- <div class="overflow_help">
                  <span class="rotate">>>></span> Подробнее <span class="rotate">>>></span>
                </div> -->
                <div class="table discount" v-if="chooseNewDevice">
                  <div class="cell left"><span></span></div>
                  <div class="cell bold"><span>Итоговая выгода</span></div>
                  <div class="cell"><span>Цена устройства</span></div>
                  <div class="cell"><span>Доп. скидка</span></div>
                  <div class="cell"><span></span></div>


                  <div class="cell left"><span>Грейд А+</span></div>
                  <div class="cell bold"><span>{{ new Intl.NumberFormat("ru-RU").format(Number(model.prices['Grade A+']) + Number(model.discounts[chooseNewDevice]["a+"])) }} {{ user.currency }}</span></div>
                  <div class="cell"><span>{{ new Intl.NumberFormat("ru-RU").format(model.prices['Grade A+']) }} {{ user.currency }}</span></div>
                  <div class="cell"><span>{{ new Intl.NumberFormat("ru-RU").format(model.discounts[chooseNewDevice]["a+"]) }} {{ user.currency }}</span></div>
                  <div class="cell"><span></span></div>


                  <div class="cell left"><span>Грейд А</span></div>
                  <div class="cell bold"><span>{{ new Intl.NumberFormat("ru-RU").format(Number(model.prices['Grade A']) + Number(model.discounts[chooseNewDevice].a)) }} {{ user.currency }}</span></div>
                  <div class="cell"><span>{{ new Intl.NumberFormat("ru-RU").format(model.prices['Grade A']) }} {{ user.currency }}</span></div>
                  <div class="cell"><span>{{ new Intl.NumberFormat("ru-RU").format(model.discounts[chooseNewDevice].a) }} {{ user.currency }}</span></div>
                  <div class="cell"><span></span></div>


                  <div class="cell left"><span>Грейд B</span></div>
                  <div class="cell bold"><span>{{ new Intl.NumberFormat("ru-RU").format(Number(model.prices['Grade B']) + Number(model.discounts[chooseNewDevice].b)) }} {{ user.currency }}</span></div>
                  <div class="cell"><span>{{ new Intl.NumberFormat("ru-RU").format(model.prices['Grade B']) }} {{ user.currency }}</span></div>
                  <div class="cell"><span>{{ new Intl.NumberFormat("ru-RU").format(model.discounts[chooseNewDevice].b) }} {{ user.currency }}</span></div>
                  <div class="cell"><span></span></div>


                  <div class="cell left"><span>Грейд C</span></div>
                  <div class="cell bold"><span>{{ new Intl.NumberFormat("ru-RU").format(Number(model.prices['Grade C']) + Number(model.discounts[chooseNewDevice].c)) }} {{ user.currency }}</span></div>
                  <div class="cell"><span>{{ new Intl.NumberFormat("ru-RU").format(model.prices['Grade C']) }} {{ user.currency }}</span></div>
                  <div class="cell"><span>{{ new Intl.NumberFormat("ru-RU").format(model.discounts[chooseNewDevice].c) }} {{ user.currency }}</span></div>
                  <div class="cell"><span></span></div>

                  <div class="cell left"><span>Грейд D</span></div>
                  <div class="cell bold"><span>{{ new Intl.NumberFormat("ru-RU").format(Number(model.prices['Grade D']) + Number(model.discounts[chooseNewDevice].d)) }} {{ user.currency }}</span></div>
                  <div class="cell"><span>{{ new Intl.NumberFormat("ru-RU").format(model.prices['Grade D']) }} {{ user.currency }}</span></div>
                  <div class="cell"><span>{{ new Intl.NumberFormat("ru-RU").format(model.discounts[chooseNewDevice].d) }} {{ user.currency }}</span></div>
                  <div class="cell"><span></span></div>

                  <div class="cell left"><span>Грейд E</span></div>
                  <div class="cell bold"><span>{{ new Intl.NumberFormat("ru-RU").format(Number(model.prices['Grade E']) + Number(model.discounts[chooseNewDevice].e)) }} {{ user.currency }}</span></div>
                  <div class="cell"><span>{{ new Intl.NumberFormat("ru-RU").format(model.prices['Grade E']) }} {{ user.currency }}</span></div>
                  <div class="cell"><span>{{ new Intl.NumberFormat("ru-RU").format(model.discounts[chooseNewDevice].e) }} {{ user.currency }}</span></div>
                  <div class="cell"><span></span></div>
                  

                </div>
                  <div class="table" v-if="!chooseNewDevice">
                    <div class="cell left"><span></span></div>
                    <div class="cell bold"><span>{{ flowType == 'mts' ? 'Итоговая выгода ' : 'Цена устройства' }}</span></div>
                    <div class="cell"><span></span></div>

                    <div class="cell left"><span>Грейд A+</span></div>
                    <div class="cell bold"><span>{{ model.prices['Grade A+'] }} {{ user.currency }}</span></div>
                    <div class="cell"><span></span></div>

                    <div class="cell left"><span>{{ flowType == 'mts' ? 'Грейд H' : 'Грейд A' }}</span></div>
                    <div class="cell bold"><span>{{ model.prices['Grade A'] }} {{ user.currency }}</span></div>
                    <div class="cell"><span></span></div>

                    <div class="cell left"><span>Грейд B</span></div>
                    <div class="cell bold"><span>{{ model.prices['Grade B'] }} {{ user.currency }}</span></div>
                    <div class="cell"><span></span></div>
                  
                    <div class="cell left"><span>Грейд C</span></div>
                    <div class="cell bold"><span>{{ model.prices['Grade C'] }} {{ user.currency }}</span></div>
                    <div class="cell"><span></span></div>
                  
                    <div class="cell left"><span>Грейд D</span></div>
                    <div class="cell bold"><span>{{ model.prices['Grade D'] }} {{ user.currency }}</span></div>
                    <div class="cell"><span></span></div>

                    <div class="cell left"><span>Грейд E</span></div>
                    <div class="cell bold"><span>{{ model.prices['Grade E'] }} {{ user.currency }}</span></div>
                    <div class="cell"><span></span></div>
                  </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>

    </div>

    <div
      class="buymodal-block__footer">
      <button
        type="button"
        class="btn cancel"
        @click.prevent="$emit('leave')">
        Отказаться
      </button>
      <button
        type="button"
        class="btn next"
        @click.prevent="nextScreen()">
        Продолжить
      </button>
    </div>

  </div>

</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  components: {
    Multiselect
  },
  props: ['model'],
  data() {
    return {
      arrayName: [
        { key: 'IMEI', name: 'IMEI' },
        // { key: 'SerialNumber', name: 'Серийный номер' },
        { key: 'ModelName', name: 'Модель' },
        // { key: 'Capacity', name: 'Объем' },
        // { key: 'Color', name: 'Цвет' },
        { key: 'manufactorer', name: 'Производитель' },
        { key: 'model', name: 'Модель' },
      ],
      chooseNewDevice: null,
      flowType: null
    }
  },
  computed: {
    ...mapState('user', ['user']),
  },

  methods: {
    ...mapActions('buyphones', ['chooseSubsidies']),
    nextScreen(){
      this.chooseSubsidies(this.chooseNewDevice);
      if (this.flowType == 'mts'){
        this.$emit('next',{nextScreen: 'verify'});
        console.log('nextScreen', this.model)
        return
      }
      this.$emit('next',{nextScreen: null});
    },
    nameWithLang ({ name, language }) {
      return `${name} — [${language}]`
    },
    openNewDevice(){
      if (((this.user.discounts!=null && this.user.discounts!=0) || this.flowType != 'mts') && Object.keys(this.model.discounts).length){
        setTimeout(()=>{this.$refs["ms_chooseNewDevice"].activate()},50)
      }
    }
  },
  beforeMount() {
    const flowType = this.$storage.get('flowType')
    console.log('flowType', flowType)
    this.flowType = flowType ? flowType : 'default'
    this.openNewDevice()
  },
}
</script>

<style lang="css">
</style>
